{
  "de": {
    "space": {
      "actions": {
        "assignOtherUnit": "Einer anderen Einheit zuweisen",
        "assignSpace": "Nebenfläche zuweisen",
        "assignUnit": "Einer Einheit zuweisen",
        "cancel": "Rückgängig machen",
        "closeEdit": "Bearbeitung schließen",
        "create_space": "Nebenfläche erstellen",
        "delete": "Entfernen",
        "edit": "Bearbeiten",
        "goToSpaces": "Neue Nebenflächen erstellen",
        "new": "Nebenfläche",
        "save": "Speichern",
        "unassign": "Einheitszuweisung aufheben",
        "unassignSpaces": "Nebenflächenzuweisung aufheben"
      },
      "attributes": {
        "category": "Typ",
        "description": "Beschreibung",
        "level": "Ebene",
        "name": "Name",
        "price_value": "Gesamtverkaufswert",
        "price_value_construction": "Baukosten",
        "price_value_land": "Grundstückswert",
        "quotity": "Anteil am Übertragungsbetrag",
        "status": "Status",
        "unit": "Einheit"
      },
      "category": {
        "bicyclestorage": "Fahrradabstellraum",
        "cellar": "Keller",
        "garagebox": "Garagenbox",
        "other": "Sonstiges",
        "outdoor_space": "Außenbereich",
        "parkinglot": "Stellplatz",
        "storage": "Abstellraum",
        "winecellar": "Weinkeller"
      },
      "labels": {
        "allSpacesAssigned": "Alle Nebenflächen wurden einer Einheit zugewiesen.",
        "assignedSpaces": "Zugewiesene Nebenflächen",
        "internal": "Intern",
        "noCategory": "Kein Typ festgelegt",
        "noSpaceAssigned": "Keine Nebenflächen zugewiesen",
        "noSpaces": "Noch keine Nebenflächen erstellt",
        "notAssignedToUnit": "Keine Einheit zugewiesen",
        "onlyAvailableSpacesShown": "Es werden nur verfügbare Nebenflächen angezeigt",
        "selectToUnassign": "Zum Trennen auswählen",
        "space": "Nebenfläche",
        "spaces": "Nebenflächen",
        "spacesProject": "Nebenflächen in Projekt {project}",
        "unassignedSpaces": "Nicht zugewiesene Nebenflächen"
      },
      "validation": {
        "needCategory": "Typ ist erforderlich",
        "needName": "Name erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 95)",
        "selectSpace": "Wählen Sie mindestens 1 Nebenfläche aus"
      }
    }
  }
}
